/**
 * Helpers Functions
 */
import { isEqual, isObject, transform } from '@/utils/collection'
import { storage } from '@/plugins/storage'

export function hashToObject(hash) {
    return (hash.match(new RegExp('([^#=&]+)(=([^&]*))?', 'g')) || [])
        .reduce((result, each) => {
            const [key, value] = each.split('=')
            result[key] = value
            return (result)
        }, {})
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function difference(object, base) {
    return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
            result[key] = isObject(value) && isObject(base[key]) ? difference(value, base[key]) : value
        }
    })
}

export const isValidUrl = (str, allowWildCard = false) => {
    if (allowWildCard && str === '*') {
        return true
    }

    const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
        + `(((${allowWildCard ? '([\\*]\\.)?' : ''}[a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|` // domain name
        + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
        + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
        + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
        + '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator

    return !!pattern.test(str)
}

export const reformatUrl = (url) => {
    const pattern = /^((http|https):\/\/)/
    if (!pattern.test(url)) {
        url = `https://${url}`
    }
    return url
}

/**
 * Check if user is authenticated by checking OAuth token
 * @returns {boolean} True if user has valid OAuth access token
 */
export function isAuthenticated() {
    const oauth = storage.get('oauth', {})
    return !!(oauth && oauth.access_token)
}
